// Internal Imports (Models & Services)
import { Equipment } from '@/api/models/Contracts';
import { ContractDetailService } from '@/api/services/contractDetailService';

// External Imports (Redux & Redux-Saga)
import { takeLatest, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

// Redux Slice Actions
import {
  fetchEquipmentStart,
  fetchEquipmentSuccess,
  fetchEquipmentFailure,
} from './equipmentSlice';
import { EquipmentRequest } from '@/api/models/BaseRequest';
import { PayloadAction } from '@reduxjs/toolkit';

/**
 * Saga function to fetch equipment data.
 * It makes an API call and dispatches either a success or failure action.
 */
function* fetchEquipmentSaga(
  action: PayloadAction<{ contractId: string, clientId : string }>,
): Generator<CallEffect<Equipment[]> | PutEffect, void, Equipment[]> {
  try {
    const payload: EquipmentRequest = {
      contractId: action.payload.contractId,
      clientId : action.payload.clientId,
      keyword: '',
      pageNo: 0,
      pageSize: 0,
    };

    const equipments: Equipment[] = yield call(ContractDetailService.fetchEquipments, payload);

    yield put(fetchEquipmentSuccess(equipments));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Fetching equipments failed';
    yield put(fetchEquipmentFailure(errorMessage));
  }
}

/**
 * Watcher Saga that listens for `fetchEquipmentRequest` actions
 * and triggers `fetchEquipmentSaga` when the action is dispatched.
 */
export function* watchEquipment(): SagaIterator {
  yield takeLatest(fetchEquipmentStart.type, fetchEquipmentSaga);
}
